export const EDITOR_FONTS_CONFIGURATION = {
    showDefaultFonts: false,
    customFonts: [
        {
            name: 'Arial',
            fontFamily: 'Arial, Helvetica, sans-serif',
        },
        {
            name: 'Arial Black',
            fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
        },
        {
            name: 'Courier',
            fontFamily: "Courier, 'Courier New', monospace",
        },
        {
            name: 'Courier New',
            fontFamily: "'Courier New', Courier, monospace",
        },
        {
            name: 'Georgia',
            fontFamily: "Georgia, 'Times New Roman', serif",
        },
        {
            name: 'Tahoma',
            fontFamily: 'Tahoma, Geneva, sans-serif',
        },
        {
            name: 'Times',
            fontFamily: 'Times, Georgia, serif',
        },
        {
            name: 'Times New Roman',
            fontFamily: "'Times New Roman', Times, serif",
        },
        {
            name: 'Trebuchet MS',
            fontFamily: "'Trebuchet MS', Arial, sans-serif",
        },
        {
            name: 'Verdana',
            fontFamily: 'Verdana, Arial, sans-serif',
        },
        {
            name: 'Arvo',
            fontFamily: "'Arvo', Verdana, serif",
            url: 'https://fonts.googleapis.com/css2?family=Arvo&display=swap',
        },
        {
            name: 'Abril Fatface',
            fontFamily: "'Abril Fatface', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap',
        },
        {
            name: 'Cabin',
            fontFamily: "'Cabin', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Cabin&display=swap',
        },
        {
            name: 'Dancing Script',
            fontFamily: "'Dancing Script', Times New Roman, cursive",
            url: 'https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap',
        },
        {
            name: 'Inconsolata',
            fontFamily: "'Inconsolata', Courier New, monospace",
            url: 'https://fonts.googleapis.com/css2?family=Inconsolata&display=swap',
        },
        {
            name: 'Lobster',
            fontFamily: "'Lobster', Georgia, Times, serif",
            url: 'https://fonts.googleapis.com/css?family=Lobster',
        },
        {
            name: 'Lora',
            fontFamily: "'Lora', Georgia, serif",
            url: 'https://fonts.googleapis.com/css?family=Lora&display=swap',
        },
        {
            name: 'Merriweather',
            fontFamily: "'Merriweather', Georgia, serif",
            url: 'https://fonts.googleapis.com/css?family=Merriweather&display=swap',
        },
        {
            name: 'Montserrat',
            fontFamily: "'Montserrat', Verdana, sans-serif",
            url: 'https://fonts.googleapis.com/css?family=Montserrat&display=swap',
        },
        {
            name: 'Nunito',
            fontFamily: "'Nunito', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Nunito&display=swap',
        },
        {
            name: 'Oswald',
            fontFamily: "'Oswald', Impact, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Oswald&display=swap',
        },
        {
            name: 'Playfair Display',
            fontFamily: "'Playfair Display', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap',
        },
        {
            name: 'Poppins',
            fontFamily: "'Poppins', Verdana, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        },
        {
            name: 'Roboto',
            fontFamily: "'Roboto', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
        },
        {
            name: 'Rubik',
            fontFamily: "'Rubik', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Rubik&display=swap',
        },
        {
            name: 'Source Sans Pro',
            fontFamily: "'Source Sans Pro', Trebuchet MS, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap',
        },
        {
            name: 'Source Serif Pro',
            fontFamily: "'Source Serif Pro', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Source+Serif+Pro&display=swap',
        },
        {
            name: 'Vollkorn',
            fontFamily: "'Vollkorn', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Vollkorn&display=swap',
        },
    ],
} as const;

export const NUTSHELL_FONTS_CONFIGURATION = {
    showDefaultFonts: false,
    customFonts: [
        {
            name: 'Arial',
            fontFamily: 'Arial, Helvetica, sans-serif',
        },
        {
            name: 'Arial Black',
            fontFamily: "'Arial Black', 'Arial Bold', Arial, sans-serif",
        },
        {
            name: 'Courier',
            fontFamily: "Courier, 'Courier New', monospace",
        },
        {
            name: 'Courier New',
            fontFamily: "'Courier New', Courier, monospace",
        },
        {
            name: 'Georgia',
            fontFamily: "Georgia, 'Times New Roman', serif",
        },
        {
            name: 'Tahoma',
            fontFamily: 'Tahoma, Geneva, sans-serif',
        },
        {
            name: 'Times',
            fontFamily: 'Times, Georgia, serif',
        },
        {
            name: 'Times New Roman',
            fontFamily: "'Times New Roman', Times, serif",
        },
        {
            name: 'Trebuchet MS',
            fontFamily: "'Trebuchet MS', Arial, sans-serif",
        },
        {
            name: 'Verdana',
            fontFamily: 'Verdana, Arial, sans-serif',
        },
        {
            name: 'Arvo',
            fontFamily: "'Arvo', Verdana, serif",
            url: 'https://fonts.googleapis.com/css2?family=Arvo&display=swap',
        },
        {
            name: 'Abril Fatface',
            fontFamily: "'Abril Fatface', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap',
        },
        {
            name: 'Cabin',
            fontFamily: "'Cabin', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Cabin&display=swap',
        },
        {
            name: 'Dancing Script',
            fontFamily: "'Dancing Script', Times New Roman, cursive",
            url: 'https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap',
        },
        {
            name: 'IBM Plex Sans',
            fontFamily: "'IBM Plex Sans', Trebuchet MS, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap',
        },
        {
            name: 'IBM Plex Serif',
            fontFamily: "'IBM Plex Serif', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Serif&display=swap',
        },
        {
            name: 'Inconsolata',
            fontFamily: "'Inconsolata', Courier New, monospace",
            url: 'https://fonts.googleapis.com/css2?family=Inconsolata&display=swap',
        },
        {
            name: 'Lobster',
            fontFamily: "'Lobster', Georgia, Times, serif",
            url: 'https://fonts.googleapis.com/css?family=Lobster',
        },
        {
            name: 'Lora',
            fontFamily: "'Lora', Georgia, serif",
            url: 'https://fonts.googleapis.com/css?family=Lora&display=swap',
        },
        {
            name: 'Merriweather',
            fontFamily: "'Merriweather', Georgia, serif",
            url: 'https://fonts.googleapis.com/css?family=Merriweather&display=swap',
        },
        {
            name: 'Montserrat',
            fontFamily: "'Montserrat', Verdana, sans-serif",
            url: 'https://fonts.googleapis.com/css?family=Montserrat&display=swap',
        },
        {
            name: 'Nunito',
            fontFamily: "'Nunito', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Nunito&display=swap',
        },
        {
            name: 'Oswald',
            fontFamily: "'Oswald', Impact, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Oswald&display=swap',
        },
        {
            name: 'Playfair Display',
            fontFamily: "'Playfair Display', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Playfair+Display&display=swap',
        },
        {
            name: 'Poppins',
            fontFamily: "'Poppins', Verdana, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Poppins&display=swap',
        },
        {
            name: 'Roboto',
            fontFamily: "'Roboto', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
        },
        {
            name: 'Rubik',
            fontFamily: "'Rubik', Arial, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Rubik&display=swap',
        },
        {
            name: 'Source Sans Pro',
            fontFamily: "'Source Sans Pro', Trebuchet MS, sans-serif",
            url: 'https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap',
        },
        {
            name: 'Source Serif Pro',
            fontFamily: "'Source Serif Pro', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Source+Serif+Pro&display=swap',
        },
        {
            name: 'Vollkorn',
            fontFamily: "'Vollkorn', Georgia, serif",
            url: 'https://fonts.googleapis.com/css2?family=Vollkorn&display=swap',
        },
    ],
} as const;
